import Fetcher from '../../common/util/Fetcher';
import { CREATE_QTI_IMPORT, FILE_UPLOAD_SUCCESS, FILE_UPLOAD_FAILURE, PARENT_TYPE_QUIZ, PARENT_TYPE_BANK } from '@instructure/quiz-common';
import { handleQtiImportsResponse } from '../../common/api/callHandlers';
import { getExistingQuizAndItems } from '../../common/api/quizzes';
import { getUploadUrl, sendFileToS3 } from '../../common/api/fileUpload';
import { getExistingBankAndEntries } from '../../banks/api/banks';
import { uploadStatus as setUploadStatus } from '../../common/actions/upload';
export var getQTIInfo = function getQTIInfo(quizId) {
  return function (dispatch, getState) {
    var fetcher = new Fetcher();
    var url = "/api/quizzes/".concat(quizId, "/qti_imports");
    var addImportsToStore = function addImportsToStore(importsList) {
      dispatch(handleQtiImportsResponse(importsList));
    };
    return fetcher.get(url).then(addImportsToStore);
  };
};
var _pollForQtiInfo = function pollForQtiInfo(parentId, parentType, waitForAssignmentSettingsImported) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    getExistingBankAndEntries: getExistingBankAndEntries,
    getExistingQuizAndItems: getExistingQuizAndItems,
    pollForQtiInfo: _pollForQtiInfo
  };
  return function (dispatch, getState) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        var fetcher = new Fetcher();
        var url;
        if (parentType === PARENT_TYPE_QUIZ) {
          url = "/api/quizzes/".concat(parentId, "/qti_imports");
        } else {
          url = "/api/banks/".concat(parentId, "/qti_imports");
        }
        var addImportsToStore = function addImportsToStore(importsList) {
          dispatch(handleQtiImportsResponse(importsList));
          if (importsList.find(function (qtiImport) {
            return qtiImport.status === 'completed';
          })) {
            if (parentType === PARENT_TYPE_QUIZ) {
              dispatch(opts.getExistingQuizAndItems(parentId));
            } else {
              dispatch(opts.getExistingBankAndEntries(parentId));
            }
            if (waitForAssignmentSettingsImported) {
              waitForAssignmentSettingsImported().then(function () {
                dispatch(setUploadStatus(FILE_UPLOAD_SUCCESS));
              });
            } else {
              dispatch(setUploadStatus(FILE_UPLOAD_SUCCESS));
            }
          } else if (importsList.find(function (qtiImport) {
            return qtiImport.status !== 'failed';
          })) {
            dispatch(opts.pollForQtiInfo(parentId, parentType, waitForAssignmentSettingsImported, opts));
          } else {
            dispatch(setUploadStatus(FILE_UPLOAD_FAILURE));
          }
        };
        return fetcher.get(url).then(addImportsToStore).then(resolve);
      }, 2000);
    });
  };
};

// =====================
//   UPLOAD A QTI FILE
// =====================

// This fxn is curried twice to allow for setting the creation url, then for receiving
// the url from the first response, and finally receives the promise.
// Exported for testing purposes
export { _pollForQtiInfo as pollForQtiInfo };
export var postQtiCreate = function postQtiCreate(qtiImportUrl, dispatch, onError, waitForAssignmentSettingsImported) {
  return function (url) {
    var qtiCreateFetcher = new Fetcher({
      callType: CREATE_QTI_IMPORT,
      onError: onError
    });
    var requestBody = JSON.stringify({
      url: url
    });
    var addImportToStore = function addImportToStore(importData) {
      dispatch(handleQtiImportsResponse([importData]));
      var parentType = importData.parent_type === 'Quiz' ? PARENT_TYPE_QUIZ : PARENT_TYPE_BANK;
      dispatch(_pollForQtiInfo(importData.parent_id, parentType, waitForAssignmentSettingsImported));
    };
    return qtiCreateFetcher.post(qtiImportUrl, {
      body: requestBody
    }).then(addImportToStore);
  };
};
export var qtiFileUpload = function qtiFileUpload(file, parentId, parentType, onError, waitForAssignmentSettingsImported) {
  var withUrlCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : sendFileToS3;
  var qtiCreateFxn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : postQtiCreate;
  return function (dispatch, getState) {
    var qtiImportUrl;
    if (parentType === PARENT_TYPE_QUIZ) {
      qtiImportUrl = "/api/quizzes/".concat(parentId, "/qti_imports");
    } else {
      qtiImportUrl = "/api/banks/".concat(parentId, "/qti_imports");
    }
    var pathToGetUrl = "".concat(qtiImportUrl, "/upload_url");
    var onSuccess = qtiCreateFxn(qtiImportUrl, dispatch, onError, waitForAssignmentSettingsImported);
    return getUploadUrl(pathToGetUrl).then(withUrlCallback(file, onSuccess, onError));
  };
};